
import Repository from '@/api/core'
const baseURL = process.env.VUE_APP_API_STUDENT + '/student'
const fetchOne = (id) => {
  return Repository(baseURL).fetchOne(id)
}
export default {
  fetchOne
}
